import React from 'react';
import { Provider } from 'react-redux';
import { Auth0Provider } from '@auth0/auth0-react';
import { Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import { ModalProvider } from '~/components/shared/Modal/ModalProvider';
import { setupStore } from '~/store';
import { history } from '~/constants';
import IntlProviderHOC from './components/hoc/IntlProviderHOC';
import Main from './Main';
import auth0Config from '~/helpers/auth0Config';
import PostHogProvider from '~/contexts/PostHogProvider/PostHogProvider';
import './react-pdf';
import {
  ComponentsLibraryProvider,
  ModalsProvider,
} from '@qred/components-library';
import { QitUiProvider } from '@qred/qit-ui';
import '~/config/sentry'; // Import Sentry configuration
import ValidationContextProvider from './components/hoc/withValidation';
import '~/mswDev';

const EnhancedIntlProvider = IntlProviderHOC(IntlProvider);
const store = setupStore();

const App = () => {
  return (
    <Provider store={store}>
      <ValidationContextProvider>
        <PostHogProvider>
          <Auth0Provider {...auth0Config}>
            <EnhancedIntlProvider>
              <QitUiProvider>
                <ComponentsLibraryProvider>
                  <ModalsProvider>
                    <ModalProvider>
                      <Router history={history}>
                        <Main />
                      </Router>
                    </ModalProvider>
                  </ModalsProvider>
                </ComponentsLibraryProvider>
              </QitUiProvider>
            </EnhancedIntlProvider>
          </Auth0Provider>
        </PostHogProvider>
      </ValidationContextProvider>
    </Provider>
  );
};

export default App;
